import React from "react";

function Wrapper({ children }) {
  return <div className="w-11/12 md:w-10/12 mx-auto h-full">{children}</div>;
}

export default Wrapper;
